import Icon from '@ant-design/icons';

import { ReactComponent as Guest } from './svgs/consulting.svg';

const GuestIcon = props => {
  return <Icon component={Guest} {...props} />;
};

export default GuestIcon;
